import PropTypes from 'prop-types'
import React from 'react'
import IntlProvider from './IntlProvider'
import UnitProvider from './UnitProvider'
import { HelmetProvider } from 'react-helmet-async'
import { Provider } from 'react-redux'
import history from '../history'
import { ConnectedRouter } from 'connected-react-router'
import { getRoutes } from '../../routes'
import JssProvider from 'react-jss/lib/JssProvider'
import { MuiThemeProvider, createGenerateClassName } from '@material-ui/core/styles'
import theme from 'application/mui/theme'

const propTypes = {
  store: PropTypes.object,
}

export function App ({ store }) {
  const generateClassName = createGenerateClassName()
  return (
    <Provider store={store}>
      <IntlProvider>
        <UnitProvider>
          <ConnectedRouter history={history}>
            <JssProvider generateClassName={generateClassName}>
              <MuiThemeProvider theme={theme}>
                <HelmetProvider>
                  {getRoutes(store)}
                </HelmetProvider>
              </MuiThemeProvider>
            </JssProvider>
          </ConnectedRouter>
        </UnitProvider>
      </IntlProvider>
    </Provider>
  )
}

App.propTypes = propTypes

export default App
